document.addEventListener("DOMContentLoaded", function () {

    /** -----------------------------
     *  SIZE GUIDE MODAL
     * ----------------------------- */

    const sizeGuideModal = document.getElementById("sizeGuideModal");
    const closeModalButton = document.getElementById("closeModal");

    document.addEventListener("click", function (e) {
        if (e.target.closest("#sizeGuideLink")) {
            sizeGuideModal.classList.add("modal--active");
        }
    });

    closeModalButton.addEventListener("click", function () {
        sizeGuideModal.classList.remove("modal--active");
    });

    sizeGuideModal.querySelector(".modal__overlay").addEventListener("click", function () {
        sizeGuideModal.classList.remove("modal--active");
    });

    /** -----------------------------
     *  SIZE CALCULATOR LOGIC
     * ----------------------------- */

    const el = document.querySelector('[data-product-category]');
    const productCategory = el?.dataset.productCategory;

    const errorElement = document.getElementById("size-error");
    const resultElement = document.getElementById("size-result");
    const sizeChartContainer = document.querySelector(".size-chart-grid-container");

    const lengthInput = document.getElementById("dog-length");
    const chestInput = document.getElementById("dog-chest");

    if (productCategory !== "632433705298" && productCategory !== "632434917714") {
        errorElement.innerHTML = "<div class='size-error-container'>This calculator only works for raincoats and bathrobes.</div>";
        return;
    }

    let sizeChart = [];

    // Raincoats
    if (productCategory == "632433705298") {
        sizeChart = [
            { size: '2XS', lengthRange: [25, 30], chestRange: [30, 56], neck: 36 },
            { size: 'XS',  lengthRange: [30, 35], chestRange: [30, 56], neck: 40 },
            { size: 'S',   lengthRange: [35, 40], chestRange: [40, 65], neck: 44 },
            { size: 'M',   lengthRange: [40, 45], chestRange: [50, 75], neck: 48 },
            { size: 'L',   lengthRange: [45, 50], chestRange: [55, 80], neck: 52 },
            { size: 'XL',  lengthRange: [50, 55], chestRange: [65, 95], neck: 64 },
            { size: '2XL', lengthRange: [60, 65], chestRange: [65, 105], neck: 68 },
            { size: '3XL', lengthRange: [70, 75], chestRange: [70, 112], neck: 72 }
        ];
    }

    // Dry Robe
    if (productCategory == "632434917714") {
        sizeChart = [
           { size: '2XS', lengthRange: [25, 30], chestRange: [32, 52], neck: 36 },
            { size: 'XS',  lengthRange: [30, 35], chestRange: [38, 59], neck: 40 },
            { size: 'S',   lengthRange: [35, 40], chestRange: [43, 67], neck: 44 },
            { size: 'M',   lengthRange: [40, 45], chestRange: [49, 76], neck: 48 },
            { size: 'L',   lengthRange: [45, 50], chestRange: [52, 81], neck: 52 },
            { size: 'XL',  lengthRange: [50, 55], chestRange: [56, 85], neck: 64 },
            { size: '2XL', lengthRange: [60, 65], chestRange: [68, 96], neck: 68 },
            { size: '3XL', lengthRange: [70, 75], chestRange: [68, 100], neck: 72 }
        ];
    }

    /** Populate Chart Table */
    function populateSizeChart() {
        const tableBody = document.querySelector("#size-chart-table tbody");
        tableBody.innerHTML = "";

        sizeChart.forEach(size => {
            const row = document.createElement("tr");
            row.innerHTML = `
                <td class="size-chart-column">${size.size}</td>
                <td>${size.lengthRange[0]} - ${size.lengthRange[1]}</td>
                <td>${size.chestRange[0]} - ${size.chestRange[1]}</td>
                <td>${size.neck}</td>
            `;
            tableBody.appendChild(row);
        });
    }

    /** Event listeners only for length and chest */
    [lengthInput, chestInput].forEach(input => {
        input.addEventListener("input", () => {
            updateSize();
            checkVisibility();
        });
    });

    /** Core Calculations (Length & Chest Only) */
    function updateSize() {
        errorElement.textContent = "";
        resultElement.textContent = "";

        const length = parseFloat(lengthInput.value) || 0;
        const chest  = parseFloat(chestInput.value) || 0;

        let sizeDetails = null;

        if (length && chest) {
            sizeDetails = sizeChart.find(size =>
                length >= size.lengthRange[0] &&
                length <= size.lengthRange[1] &&
                chest >= size.chestRange[0] &&
                chest <= size.chestRange[1]
            );
        } else if (length) {
            sizeDetails = sizeChart.find(size =>
                length >= size.lengthRange[0] &&
                length <= size.lengthRange[1]
            );
        } else if (chest) {
            sizeDetails = sizeChart.find(size =>
                chest >= size.chestRange[0] &&
                chest <= size.chestRange[1]
            );
        } else {
            errorElement.innerHTML = "<div class='size-error-container'>Please enter at least one measurement.</div>";
            return;
        }

        if (!sizeDetails) {
            errorElement.innerHTML = "<div class='size-error-container'>No matching size found.</div>";
            return;
        }

        resultElement.innerHTML = `
            <h3 class="size-title">${sizeDetails.size}</h3>
            <small><strong>Recommended Size</strong></small>
            <ul class="size-table">
                <li><strong>Length:</strong> <p>${sizeDetails.lengthRange[0]} - ${sizeDetails.lengthRange[1]} cm</p></li>
                <li><strong>Chest:</strong> <p>${sizeDetails.chestRange[0]} - ${sizeDetails.chestRange[1]} cm</p></li>
                <li><strong>Neck:</strong> <p>${sizeDetails.neck} cm</p></li>
            </ul>`;
    }

    function checkVisibility() {
        const hasValue =
            lengthInput.value ||
            chestInput.value ||
            resultElement.innerHTML.trim() !== "";

        if (hasValue) sizeChartContainer.classList.add("hidden");
        else sizeChartContainer.classList.remove("hidden");
    }

    /** Toggle Nav Buttons */
    const buttons = document.querySelectorAll(".size-nav button");
    const sizeResult = document.getElementById("dog-size-calculator");
    const chartResult = document.getElementById("chart-result");

    buttons.forEach(button => {
        button.addEventListener("click", function () {
            buttons.forEach(btn => btn.classList.remove("active"));
            this.classList.add("active");

            if (this.textContent.includes("Size Calculator")) {
                sizeResult.classList.remove("size-chart-hidden");
                chartResult.classList.add("size-chart-hidden");
            } else {
                sizeResult.classList.add("size-chart-hidden");
                chartResult.classList.remove("size-chart-hidden");
            }
        });
    });

    populateSizeChart();
});
